// Third-party Library
import React from "react"
import { useSelector } from "react-redux"
import { Card, Row, Col, Typography, Tag, Divider, Button } from "antd"
import { ExportOutlined } from "@ant-design/icons"

// Templates
import { TEMPLATE } from "../../../../../../constants"

// Components
import PretripContentDrawer from "../PretripContentDrawer"
import { reduxStoreWrapper } from "../../../../../../services/util/redux"

// Handlers
import { pdf_handler } from "../../../../../../handlers"

// import PreTripInspectionReport from "../../../../../../handlers/pdfHDLR/PretripInspectionReport"
// Styles
import styles from '../../index.module.css'


const { Title, Text } = Typography

const {
    PRETRIP_HISTORY_STATUS_LABEL: statusConfig,
    PRETRIP_HISTORY_STATUS: STATUS
} = TEMPLATE.PRETRIP

const {
    PretripInspectionReport,
    exportToPDF
} = pdf_handler

const DetailCard = ({ data={}, isOpenDrawer, setIsOpenDrawer }) => {

    const driverPretrips = useSelector(reduxStoreWrapper("drivers.pretripByID"))
    // console.log(driverPretrips[data.dpid])

    const newData = {
        ...data,
        ...driverPretrips[data.dpid]
    }

  if (!newData.date) {
    return (
      <Card size="small" style={{ borderRadius: 12 }}>
        <Title level={5}>Selected Date Details</Title>
        <Text style={{ color: "#9ca3af", fontSize: 13 }}>Click a date to see details</Text>
      </Card>
    )
  }

    const cfg = newData ? statusConfig[newData.status] : null


    const pretrips = newData.pretripDetails?.reduce((acc, curr) => {
        const category = curr.category;
        
        if (!acc[category]) acc[category] = []
        
        acc[category].push(curr);
        
        return acc
    }, {});

    const exportDetailToPDFHDLR = async () => {   
        await new Promise((resolve) => setTimeout(resolve, 50));
        await exportToPDF('document-page', `Pre-trip Detail_${newData?.createdAt}`)
    };
        
    return (
        <Card size="small" style={{ borderRadius: 12 }}>
            {
                isOpenDrawer
                &&
                <PretripContentDrawer pretrips={pretrips} isOpenDrawer={isOpenDrawer} setIsOpenDrawer={setIsOpenDrawer} newData={newData} exportDetailToPDFHDLR={exportDetailToPDFHDLR} />
            }
            <div className={styles["pdf-report"]} aria-hidden="true" >
                <PretripInspectionReport data={driverPretrips[newData.dpid]}/>
            </div>

            <Row justify="space-between" align="middle" style={{ marginBottom: 4 }}>
                <Title level={5} style={{ margin: 0 }}>Selected Date Details</Title>
                {
                    cfg && (
                        <Tag color={cfg.tagColor} style={{ fontWeight: 500, borderRadius: 6 }}>
                            {cfg.label}
                        </Tag>
                    )
                }
            </Row>

            <Text className={styles["detail-date"]}>{data.date}</Text>

            {(data && data.dpid) ? (
                <>
                    <Row gutter={[8, 4]} style={{ fontSize: 12 }}>
                        <Col span={12}>
                        <Text style={{ color: "#6b7280", fontSize: 12 }}>Driver</Text>
                        </Col>
                        <Col span={12}>
                        <Text style={{ color: "#6b7280", fontSize: 12 }}>Vehicle</Text>
                        </Col>
                        <Col span={12}>
                        <Text strong style={{ fontSize: 12 }}>{newData.driver}</Text>
                        </Col>
                        <Col span={12}>
                        <Text strong style={{ fontSize: 12 }}>{newData.vehicle}</Text>
                        </Col>
                        <Col span={12} style={{ marginTop: 6 }}>
                        <Text style={{ color: "#6b7280", fontSize: 12 }}>Status</Text>
                        </Col>
                        <Col span={12} style={{ marginTop: 6 }}>
                        <Text style={{ color: "#6b7280", fontSize: 12 }}>Submitted Time</Text>
                        </Col>
                        <Col span={12}>
                        <Text strong style={{ fontSize: 12, color: cfg.textColor }}>
                            {data.status === STATUS.MISSING ? "Pretrip form not submitted" : cfg.label}
                        </Text>
                        </Col>
                        <Col span={12}>
                        <Text strong style={{ fontSize: 12 }}>{newData.date ?? "—"}</Text>
                        </Col>
                    </Row>

                    <Divider style={{ margin: "10px 0" }} />

                    <Text style={{ color: "#6b7280", fontSize: 12 }}>Notes</Text> <br />
                    <Text style={{ fontSize: 12 }}>{data.note}</Text>

                    <Button
                        type="primary"
                        block
                        className={styles["detail-viewreport-btn"]}
                        icon={<ExportOutlined />}
                        disabled={!newData.dpid}
                        onClick={() => setIsOpenDrawer(true)}
                    >
                        View Report
                    </Button>
                </>
            ) : (
                <Text className={styles["detail-no-report"]}>No data for this date.</Text>
            )}
        </Card>
    )
}

export default React.memo(DetailCard)